var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.confirmLoading } },
    [
      _c(
        "j-form-container",
        { attrs: { disabled: _vm.formDisabled } },
        [
          _c(
            "a-form-model",
            {
              ref: "form",
              attrs: {
                slot: "detail",
                model: _vm.model,
                rules: _vm.validatorRules
              },
              slot: "detail"
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-card",
                    { attrs: { title: "请求参数", bordered: false } },
                    [
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "api类型",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "apiType"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "radio",
                                  "trigger-change": true,
                                  dictCode: "hhemp_aicsp_apitype",
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.model.apiType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "apiType", $$v)
                                  },
                                  expression: "model.apiType"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "category",
                                labelCol: _vm.labelCol1,
                                wrapperCol: _vm.wrapperCol1,
                                prop: "category"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "radio",
                                  "trigger-change": true,
                                  dictCode: "hhemp_aicsp_category",
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.model.category,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "category", $$v)
                                  },
                                  expression: "model.category"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "a-col",
                        { attrs: { span: 8 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "lang",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "lang"
                              }
                            },
                            [
                              _c("j-dict-select-tag", {
                                attrs: {
                                  type: "radio",
                                  "trigger-change": true,
                                  dictCode: "hhemp_aicsp_lang",
                                  disabled: _vm.formDisabled
                                },
                                model: {
                                  value: _vm.model.lang,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "lang", $$v)
                                  },
                                  expression: "model.lang"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.model.apiType === "chatWithKnowledge" ||
                      _vm.model.apiType === "cspChatWithKnowledge"
                        ? _c(
                            "a-col",
                            { attrs: { span: 8 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "convertTextToSpeech",
                                    labelCol: _vm.labelCol2,
                                    wrapperCol: _vm.wrapperCol2,
                                    prop: "convertTextToSpeech"
                                  }
                                },
                                [
                                  _c("j-dict-select-tag", {
                                    attrs: {
                                      type: "radio",
                                      "trigger-change": true,
                                      dictCode: "hhemp_isthird",
                                      disabled: _vm.formDisabled
                                    },
                                    model: {
                                      value: _vm.model.convertTextToSpeech,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "convertTextToSpeech",
                                          $$v
                                        )
                                      },
                                      expression: "model.convertTextToSpeech"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "操作用户账号",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "userid"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入操作用户账号"
                                    },
                                    model: {
                                      value: _vm.model.userid,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "userid", $$v)
                                      },
                                      expression: "model.userid"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "操作用户名称",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "username"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入操作用户名称"
                                    },
                                    model: {
                                      value: _vm.model.username,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "username", $$v)
                                      },
                                      expression: "model.username"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "请求java方法",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "method"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: {
                                      placeholder: "请输入请求java方法"
                                    },
                                    model: {
                                      value: _vm.model.method,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "method", $$v)
                                      },
                                      expression: "model.method"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "content",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "content"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: {
                                  maxLength: "1000",
                                  rows: "4",
                                  placeholder: "请输入content"
                                },
                                model: {
                                  value: _vm.model.content,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "content", $$v)
                                  },
                                  expression: "model.content"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "请求路径",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "requestUrl"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入请求路径" },
                                    model: {
                                      value: _vm.model.requestUrl,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "requestUrl", $$v)
                                      },
                                      expression: "model.requestUrl"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "请求参数",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "requestParam"
                                  }
                                },
                                [
                                  _c("a-textarea", {
                                    attrs: {
                                      rows: "4",
                                      placeholder: "请输入请求参数"
                                    },
                                    model: {
                                      value: _vm.model.requestParam,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "requestParam", $$v)
                                      },
                                      expression: "model.requestParam"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "请求类型",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "requestType"
                                  }
                                },
                                [
                                  _c("a-input", {
                                    attrs: { placeholder: "请输入请求类型" },
                                    model: {
                                      value: _vm.model.requestType,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "requestType", $$v)
                                      },
                                      expression: "model.requestType"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "耗时",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "costTime"
                                  }
                                },
                                [
                                  _c("a-input-number", {
                                    staticStyle: { width: "100%" },
                                    attrs: { placeholder: "请输入耗时" },
                                    model: {
                                      value: _vm.model.costTime,
                                      callback: function($$v) {
                                        _vm.$set(_vm.model, "costTime", $$v)
                                      },
                                      expression: "model.costTime"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.model.id
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "响应结果",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "responseResult"
                                  }
                                },
                                [
                                  _c("a-textarea", {
                                    attrs: {
                                      rows: "4",
                                      placeholder: "请输入响应结果"
                                    },
                                    model: {
                                      value: _vm.model.responseResult,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "responseResult",
                                          $$v
                                        )
                                      },
                                      expression: "model.responseResult"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c(
                    "a-card",
                    { attrs: { title: "响应参数", bordered: false } },
                    [
                      (_vm.model.apiType === "chatWithKnowledge" ||
                        _vm.model.apiType === "cspChatWithKnowledge") &&
                      _vm.model.responseResult
                        ? _c(
                            "a-col",
                            { attrs: { span: 24 } },
                            [
                              _c(
                                "a-form-model-item",
                                {
                                  attrs: {
                                    label: "回答",
                                    labelCol: _vm.labelCol,
                                    wrapperCol: _vm.wrapperCol,
                                    prop: "responseResult"
                                  }
                                },
                                [
                                  _c("a-textarea", {
                                    attrs: { rows: "5", disabled: "true" },
                                    model: {
                                      value: JSON.parse(
                                        _vm.model.responseResult
                                      ).content,
                                      callback: function($$v) {
                                        _vm.$set(
                                          JSON.parse(_vm.model.responseResult),
                                          "content",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "JSON.parse(model.responseResult).content"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "a-col",
                        { attrs: { span: 24 } },
                        [
                          _c(
                            "a-form-model-item",
                            {
                              attrs: {
                                label: "响应结果",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                                prop: "responseResult"
                              }
                            },
                            [
                              _c("a-textarea", {
                                attrs: { rows: "10", disabled: "true" },
                                model: {
                                  value: _vm.model.responseResult,
                                  callback: function($$v) {
                                    _vm.$set(_vm.model, "responseResult", $$v)
                                  },
                                  expression: "model.responseResult"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("a-col", { attrs: { span: 24 } }, [
                        _vm.model.convertTextToSpeech === "1"
                          ? _c(
                              "div",
                              [
                                _c(
                                  "a-form-model-item",
                                  {
                                    attrs: {
                                      label: "Audio",
                                      labelCol: _vm.labelCol,
                                      wrapperCol: _vm.wrapperCol,
                                      prop: "responseResult"
                                    }
                                  },
                                  [
                                    _c("audio", {
                                      ref: "audioElement",
                                      attrs: { controls: "" }
                                    })
                                  ]
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "a-row",
                [
                  _c("a-col", { attrs: { span: 20 } }),
                  _c(
                    "a-col",
                    { attrs: { span: 4 } },
                    [
                      _c(
                        "a-button",
                        {
                          staticStyle: { "margin-right": "8px", right: "10px" },
                          attrs: { icon: "reload" },
                          on: { click: _vm.reset }
                        },
                        [_vm._v("重置")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }